// extracted by mini-css-extract-plugin
var _1 = "ISAKDdoHLJ1w7i2QxTfb";
var _2 = "_LYV9I08_VRb2uWbVowW";
var _3 = "wPlwZUqdAOoDoSPJL_QM";
var _4 = "aCMVFdPQAP_v1UlWZIzw";
var _5 = "irCC3ABktNJOT8L0IO9p";
var _6 = "EMWnJP1s8RiSi6ssUXBV";
export { _1 as "about", _2 as "actions", _3 as "allowAll", _4 as "details", _5 as "manage", _6 as "modal" }
